































import {Component, Inject, Prop, Vue, Watch} from "vue-property-decorator"
import {Getter} from 'vuex-class';
import StoriesItem from "~/stories_widget/models/StoriesItem"
import {WidgetStoriesOptions} from "~/stories_widget/models/WidgetStoriesOptions"
import isString from 'lodash/isString'
import {ClickOnStoryInternalPayload, STORY_READER_WINDOW_REFERER} from "~/types";
import {StoriesStatistic} from "~/stories_widget/components/StoriesStatistic";
import {ensureSession, Session} from "~/stories_widget/models/Session";
import {STORY_LIST_TYPE} from "~/stories_widget/store/vuex-stories-module";
import StoriesCardItemFavoriteCells from "~/stories_widget/components/Stories/StoriesCardItemFavoriteCells.vue";

interface StylesObject {
    [key: string]: string
}

const namespace: string = 'shared';

@Component({
    name: "StoryCardItem",
    components: {
        StoriesCardItemFavoriteCells
    }
})
export default class StoriesListItem extends Vue {
    // name: "stories-list-item",
    @Prop({required: true}) readonly item!: StoriesItem;
    @Prop({required: true}) readonly index!: number;
    @Prop({required: false}) readonly dragScrollStartAt!: Nullable<Date>;
    @Prop({required: false, default: () => STORY_LIST_TYPE.default}) readonly listType!: STORY_LIST_TYPE;
    @Prop({required: false, default: () => STORY_READER_WINDOW_REFERER.default}) readonly windowReferer!: STORY_READER_WINDOW_REFERER;
    // inject: ['reOrderItems'],
    @Inject('reOrderItems') reOrderItems!: Function

    // @State('stories') stories: StoriesState;
    // @Action()

    @Getter('storiesStyle', {namespace}) storiesStyle!: string;
    @Getter('storiesHeight', {namespace}) storiesHeight!: number;

    @Getter('storiesListItemBoxShadow', {namespace}) storiesListItemBoxShadow!: Nullable<string>;
    @Getter('storiesListItemBoxShadowRead', {namespace}) storiesListItemBoxShadowRead!: Nullable<string>;
    @Getter('storiesListItemOpacity', {namespace}) storiesListItemOpacity!: Nullable<number>;
    @Getter('storiesListItemOpacityRead', {namespace}) storiesListItemOpacityRead!: Nullable<number>;
    @Getter('items', {namespace}) items!: Map<number, StoriesItem>;

    get story() {
        // fallback for favorite cell
        return this.items.get(this.item.id) as StoriesItem || this.item;
    }

    get hasVideoCover(): boolean {
        return this.story.videoCoverSrc !== null;
    }

    get classList(): Array<string | object> {
        const background = this.story.background;
        let backgroundClass = '';
        if (background !== undefined) {
            backgroundClass = `_background-color-${background.color}` + (background.gradient === true ? '-gradient' : '')
        }
        return [
            backgroundClass,
            {'_is-read': this.story.isOpened},

            {'_format-rectangle': this.storiesStyle === WidgetStoriesOptions.STYLE_RECTANGLE},
            {'_format-circle': this.storiesStyle === WidgetStoriesOptions.STYLE_CIRCLE},
            {'_format-quad': this.storiesStyle === WidgetStoriesOptions.STYLE_QUAD},
            {'_favorite-cell': this.story.favorite_cell}
        ]
    }

    get cardAspectRatio(): number {
        if (this.storiesStyle === WidgetStoriesOptions.STYLE_CIRCLE || this.storiesStyle === WidgetStoriesOptions.STYLE_QUAD) {
           return 1;
        } else if (this.storiesStyle === WidgetStoriesOptions.STYLE_RECTANGLE) {
            return .8;
        }
        return 1;
    }

    get styleList(): Dict<any> {

        let styles = {
            width: '0px',
            opacity: 1,
            boxShadow: 'unset',
        };

        styles.width = `${this.cardAspectRatio * this.storiesHeight}px`;

        if (this.storiesListItemBoxShadow !== null) {
            styles.boxShadow = this.storiesListItemBoxShadow;
        }
        if (this.storiesListItemOpacity !== null) {
            styles.opacity = this.storiesListItemOpacity;
        }
        if (this.story.isOpened) {
            if (this.storiesListItemBoxShadowRead !== null) {
                styles.boxShadow = this.storiesListItemBoxShadowRead;
            }
            if (this.storiesListItemOpacityRead !== null) {
                styles.opacity = this.storiesListItemOpacityRead;
            }
        }



        return styles;
    }

    get imageStyle(): Object {
        let styles: StylesObject = {};
        if (this.story.imageSrc !== null && !this.hasVideoCover) {
            (<any>Object).assign(styles, {"background-image": `url('${this.story.imageSrc}')`})
        }
        return styles
    }

    get titleStyle(): Object {
        let styles: StylesObject = {};
        if (this.story.title_color) {
            (<any>Object).assign(styles, {"color": this.story.title_color})
        }
        return styles
    }

    get isReaded(): boolean {
        return this.story.isOpened
    }

    // onStoriesItemClick(id) {
    //     this.$store.commit('SET_ACTIVE_STORY', {storyId: id})
    // }

    @Watch('isReaded')
    onIsReadedChanged(to: boolean, from: boolean) {
        if (to === true && from === false) {
            this.reOrderItems()
        }
    }

    mounted() {
        this.$on('click:item', (item: StoriesItem, index: number): void => {

            if (this.dragScrollStartAt !== null && this.dragScrollStartAt.getTime() <= (new Date()).getTime()) {
                return;
            }

            // first load data and context

            const validDeeplink = isString(item.deeplink) && item.deeplink.trim().length > 0;

            if (item.hide_in_reader && !validDeeplink) {
                console.error('Cannot open hidden narrative id' + item.id);
                return;
            }

            let session: Session = this.$store.getters['shared/session'];
            if (session.closed) {
                ensureSession().then((newSession) => {
                    // if (newSession) {
                    //     this.$emit('sessionInitInternal', newSession.rawData);
                    // }
                });
            }

            const clickEvent = {
                id: item.id,
                index,
                isDeeplink: false,
                url: item.deeplink ?? undefined,
            };

            if (validDeeplink && item.deeplink !== null) {
                clickEvent.isDeeplink = true;
                clickEvent.url = item.deeplink as string;

                // стата - имитация 0-го слайда
                StoriesStatistic.clickOnDeeplinkHandler({storyId: item.id}, () => {
                    this.$emit('clickOnStory', clickEvent);
                    // const deeplink: string = item.deeplink as string;
                    // window.open(deeplink, '_parent');
                });


                return;
            }

            this.$emit('clickOnStory', clickEvent);

            const clickOnStoryInternalPayload =
                {
                    id: item.id,
                    listType: this.listType,
                    windowReferer: this.windowReferer,
                } as ClickOnStoryInternalPayload;
            this.$emit('clickOnStoryInternal', clickOnStoryInternalPayload);

            // const ids: Array<number> = [];
            // this.$store.getters['stories/activeStories'].forEach((item: StoriesItem) => {
            //     ids.push(item.id)
            // });
            //
            // this.$store.dispatch('stories/FETCH_STORIES_CONTEXT', ids).then(() => {
            //     debug('stories context loaded');
            //     this.$store.dispatch('stories/FETCH_STORY', item.id).then((): void => this.$store.commit('stories/SET_ACTIVE_STORY', item.id))
            //     // fullScreen(document.querySelector('#app_bottom'))
            //
            // });


        })

    }


}
